import "./_circular-progress.scss";

/**
 * Pure SVG ring progress indicator. Rebuild of the old
 * components/ui/CircularTracker - same math, BEM class names, moved here
 * since it has 3 real consumers spanning two features (the setup checklist
 * and the sidenav SetupTracker widget), not just one.
 */
const CircularProgress = ({ percentage = 0, size = 24, strokeWidth = 1 }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const dash = (percentage / 100) * circumference;

  return (
    <svg className="circular-progress" width={size} height={size}>
      <circle
        className="circular-progress__track"
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeWidth={strokeWidth}
        fill="none"
      />
      <circle
        className="circular-progress__fill"
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeWidth={strokeWidth}
        fill="none"
        strokeDasharray={`${dash} ${circumference}`}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
    </svg>
  );
};

export default CircularProgress;
